import { FC, useContext, useEffect } from 'react';
import { LandingLayout } from '../components/layouts';
import { CenteredContent } from '../components/CenteredContent';
import { NextButton } from '../components/NextButton';
import { AuthStore, BrandStore } from '../../context';
import { history } from "../../history";
import { useNextApplicationPath } from '../../hooks';

export const WelcomePage: FC = () => {
  const {
    state: { auth },
  } = useContext(AuthStore);
  const {
    state: { brand, brandName },
  } = useContext(BrandStore);
  const { pathname } = window.location;
  const nextPath = useNextApplicationPath();
  const [logo] = (brand && (brand?.logoSquare || brand.logoPngWide)) || [];
  const acknowledgments =
    (auth && auth.user && auth.user.acknowledgments) || {};

  useEffect(() => {
    if (
      nextPath &&
      brandName !== 'fattmerchant' &&
      pathname?.includes('/welcome')
    ) {
      history.push(nextPath);
    }
  }, [brandName, nextPath, pathname]);

  useEffect(() => {
    if (!acknowledgments.setPassword) {
      history.push('/sign-up');
    }
  }, [acknowledgments.setPassword]);

  return (
    <LandingLayout triggerAnimateSplash={true} reversed={true}>
      <CenteredContent
        id="welcome"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: 'spring', stiffness: 100 }}
        exit={{ opacity: 0, y: -20 }}
        $gridTemplateRows={'2fr auto auto 3fr'}
      >
        <div>{/** Placeholder for back button so CSS works */}</div>
        <h2 style={{ textAlign: 'center' }}>
          Welcome to {brand?.platformName || 'Stax'}
        </h2>
        <div style={{ textAlign: 'center' }}>
          {logo?.url && (
            <img
              style={{ width: '106.26px' }}
              src={logo?.url}
              alt={brand?.name}
            />
          )}
          <p style={{ textAlign: 'center' }}>
            We need some info from you to verify your business. This will only
            take a few minutes.
          </p>
        </div>
        <NextButton
          id="welcome-next"
          formProps={{} as any}
          onClick={() => history.push(nextPath!)}
        />
      </CenteredContent>
    </LandingLayout>
  );
};
